// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"LidlDocument_titleBox__3CpcG","containerDropZone":"LidlDocument_containerDropZone__2_ozl"};